import React from "react";
import { useQueryClient } from "react-query";
import { format, parseJSON } from "date-fns";
import { FaUserAstronaut } from "react-icons/fa";
import titleize from "underscore.string/titleize";
import humanize from "underscore.string/humanize";
import {
  ResponsiveTable, Layouts, Loaders, Buttons,
} from "./../../components";
import { formatMoney } from "./../../utils/currrency";
import {
  useOfferInvestorsList,
  useExportOfferInvestorsList,
} from "./../../queries/offer";
import { useSessionContext } from "../../contexts/SessionContext";

function InvestorsList({companyId, offerId}) {
  const queryClient = useQueryClient();
  const { isPermitted, ACTIONS } = useSessionContext();
  const {data:investorsList, isLoading} = useOfferInvestorsList({offer_id: offerId})
  const canExport = isPermitted(ACTIONS.EXPORT_INVESTORS, companyId)

  const _exportOfferInvestorsList = useExportOfferInvestorsList({offer_id: offerId})
  const exportInvestors = async () => {
    queryClient.refetchQueries(
      ['offer', offerId, 'export-investors'],
      {
        enabled: true,
      }
    );
  }

  const tableData = React.useMemo(
    () => {
      if (investorsList)
        return investorsList
      else
        return []
    },
    [investorsList]
  );


  const columns = React.useMemo(
    () => {
      if (investorsList){
        return [
          { 
            Header: 'Investor name',
            accessor: 'first_name',
            Cell: ({row}) => {
              return <div className="d-flex align-items-center">
                <FaUserAstronaut color='#676767' className="me-2" />
                <div>{titleize([row.original.first_name, row.original.last_name].filter(Boolean).join(' '))}</div>
              </div>
            },
          },
          { 
            Header: 'Investor type',
            accessor: 'accredited',
            Cell: ({value}) => value ? 'Accredited' : 'Retail',
          },
          { 
            Header: 'Inv. date',
            accessor: 'created_at',
            Cell: ({value}) => format(parseJSON(value), 'MMM dd, yyyy'),
          },
          { 
            Header: 'Inv. amount',
            accessor: 'amount',
            Cell: ({value}) => formatMoney(value),
          },
          { 
            Header: 'Inv. status',
            accessor: 'status',
            Cell: ({value}) => titleize(humanize(value)),
          },
        ]
      }
      else{
        return []
      }
    },
    [investorsList]
  );

  if (isLoading)
    return <Loaders.TableLoader />

  return (
    <>
      <Layouts.OverviewSubheader
        left='Investors'
        right={canExport ? <Buttons.TextButton title='Export All' onClick={exportInvestors}/> : null}
        tooltipDesc="All the investors in this offer."
      />
      <ResponsiveTable title="Investors" columns={columns} data={tableData} />
    </>
  )
}

export default InvestorsList;
